/** Сколько после выхода из редактора досье считает, что вернулись из него (returnedFromEditor). */
const SUPPRESS_MS = 15000
const STORAGE_KEY = 'soyka-editor-leave'

/**
 * Запомнить уход из редактора, чтобы досье не открыло его снова само.
 *
 * @param {string} dockey документ, из которого вышли
 */
export function markEditorLeft(dockey) {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        dockey: String(dockey || ''),
        at: Date.now(),
      })
    )
  } catch (error) {
    console.error(
      '[soykajs] не удалось сохранить метку выхода из редактора в sessionStorage',
      error
    )
  }
}

/**
 * Снять запрет: пользователь сам открыл файл.
 */
export function clearEditorLeft() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    console.error(
      '[soykajs] не удалось удалить метку выхода из редактора из sessionStorage',
      error
    )
  }
}

/**
 * @returns {{ dockey: string, at: number } | null}
 */
function readEditorLeft() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return null
    }
    const data = JSON.parse(raw)
    if (!data?.at || Date.now() - Number(data.at) > SUPPRESS_MS) {
      clearEditorLeft()
      return null
    }
    return {
      dockey: String(data.dockey || ''),
      at: Number(data.at),
    }
  } catch (error) {
    console.error(
      '[soykajs] не удалось прочитать метку выхода из редактора из sessionStorage',
      error
    )
    return null
  }
}

/**
 * true, если из редактора вышли недавно (метка не старше SUPPRESS_MS).
 *
 * @returns {boolean}
 */
export function editorJustLeft() {
  return Boolean(readEditorLeft())
}
